module.exports = __webpack_public_path__ + "media/images/icon_chevron-right-f4fe4481a2780d74e1381259e032c557.svg";